<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <material-card
      icon="mdi-format-list-numbered-rtl"
      icon-small
      title="گزارش اعضا واریز نکرده"
      color="accent"
      :loading="loading"
    >
      <v-row>
        <v-col
          cols="12"
          style="padding: 0 40px 40px"
        >
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-select
                v-model="month"
                clearable
                required
                single-line
                return-object
                :items="months"
                label="ماه"
                :error-messages="errorMessages"
                :rules="[() => !!month || 'ماه را انتخاب کنید']"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
              style="text-align: right"
            >
              <v-btn
                color="primary"
                dark
                class="mx-1"
                @click="loadData"
              >
                دریافت اطلاعات
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
                single-line
                hide-details
                class="mb-5"
              />
            </v-col>
            <v-col cols="12">
              <v-responsive
                class="overflow-y-auto"
                max-height="calc(90vh0)"
              >
                <v-data-table
                  :headers="headers"
                  :items="reportData"
                  :items-per-page="50"
                  :search="search"
                  class="elevation-1"
                >
                  <template v-slot:item="row">
                    <tr>
                      <td>
                        {{ row.item.fullName }}
                      </td>
                      <td>
                        {{ row.item.personalCode }}
                      </td>
                      <td>
                        {{ row.item.officeUnit }}
                      </td>
                      <td>
                        {{ row.item.hoghoghiUnit }}
                      </td>
                      <td>
                        {{ row.item.loanTitle }}
                      </td>
                      <td class="text-center">
                        {{ row.item.amount.toString().toPriceFormat() }}
                      </td>
                      <td class="text-center">
                        {{ row.item.remain.toString().toPriceFormat() }}
                      </td>
                      <td class="text-center">
                        {{ row.item.persianStartDate.date }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-responsive>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </material-card>
    <confirm-dlg ref="confirm" />
    <div class="py-3" />
  </v-container>
</template>

<script>
  import api from '@/util/app-api'
  import toast from '@/util/toast'

  export default {
    name: 'NoPayments',
    components: {
      ConfirmDlg: () => import('@/components/Confirm'),
    },
    data () {
      return {
        errorMessages: '',
        months: [],
        month: '',
        search: '',
        saveType: 3,
        loading: false,
        reportData: [],
        headers: [
          {
            text: 'نام',
            align: 'center',
            sortable: true,
            value: 'fullName',
          },
          {
            text: 'کد پرسنلی',
            align: 'start',
            sortable: true,
            value: 'personalCode',
          },
          {
            text: 'واحد اداری',
            align: 'start',
            sortable: true,
            value: 'officeUnit',
          },
          {
            text: 'واحد حقوقی',
            align: 'start',
            sortable: true,
            value: 'hoghoghiUnit',
          },
          {
            text: 'نوع وام',
            align: 'center',
            sortable: true,
            value: 'loanTitle',
          },
          {
            text: 'مبلغ وام',
            align: 'center',
            sortable: true,
            value: 'amount',
          },
          {
            text: 'مانده',
            align: 'center',
            sortable: true,
            value: 'remain',
          },
          {
            text: 'تاریخ شروع',
            align: 'center',
            sortable: true,
            value: 'persianStartDate',
          },
        ],
      }
    },
    mounted () {
      this.getMonths()
    },
    methods: {
      getMonths () {
        this.loading = true
        api
          .get('admin/report/GetMonths', {})
          .then((response) => {
            this.months = response
          })
          .catch((err) => {
            toast.error(err.message)
          })
          .finally((x) => {
            this.loading = false
          })
      },
      loadData () {
        this.loading = true
        api
          .get(
            'admin/report/NoPayments/?month=' + this.month, {}
          )
          .then((response) => {
            this.reportData = response
          })
          .catch((err) => {
            toast.error(err.message)
          })
          .finally((x) => {
            this.loading = false
          })
      },
    },
  }
</script>
<style>
</style>
